import * as actions from '../actionTypes';
import restaurantOrderActions from '../actionTypes/restaurantOrderActions';

const initialState = {
  isLoading: true,
  meals: [],
};

const restaurantOrder = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_RESTAURANT_ORDER:
      return { ...state, isLoading: true };
    case actions.GET_RESTAURANT_ORDER_SUCCESS:
      return {
        ...action.payload.data,
        isLoading: false,
        disableStartDelivery: !(
          action.payload.data.meals.reduce((cnt, o) => cnt + o.meal.todays_total_orders, 0) > 0
        ),
      };
    case actions.GET_RESTAURANT_ORDER_FAILED:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      };

    case actions.GET_RESTURANT_ORDER_DETAILS:
    case actions.GET_RESTURANT_ORDER_DETAILS_SUCCESS:
      return { ...state, ...action.payload.data };
    case restaurantOrderActions.updateRestaurantServiceStaus:
      return {
        ...state,
        isUpdating: true,
        order_details: {
          ...state.order_details,
          restaurant_service_status: action.payload,
        },
      };
    case restaurantOrderActions.updateRestaurantServiceStausSuccess:
      return {
        ...state,
        isUpdating: false,
      };
    case restaurantOrderActions.updateRestaurantServiceStausFailed:
      return {
        ...state,
        isUpdating: false,
        order_details: {
          ...state.order_details,
          restaurant_service_status: !state.order_details
            .restaurant_service_status,
        },
      };

    default:
      return state;
  }
};

export default restaurantOrder;
